import RestClient from './rest-client'

export default class FiscalDatum extends RestClient {
  static get url () {
    return this.apiUrl + '/fiscal_data'
  }
  
  static get paramKey () {
    return 'fiscal_datum'
  }

  static async export (params) {
    const { data } = await this.http({
      url: this.url + '/export',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }
}
